import React from "react";
import BoxBedModelwithpriceRMI2026 from "../images/Box Bed Model with price RMI - 2026.pdf";

export default function VerticalEnquiryButton() {
  return (
    <div
      style={{
        position: "fixed",
        right: "0px",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 9999,
      }}
    >
        <a href={BoxBedModelwithpriceRMI2026} target="_blank" rel="noopener noreferrer">
      <button
        style={{
          writingMode: "vertical-lr", // <-- changed for proper upright text
          textOrientation: "mixed",    // ensures letters are upright
          padding: "19px 7px",
          backgroundColor: "#75500b",
          color: "#ffffff",
          borderRadius: "12px 0 0 12px",
          border: "none",
          cursor: "pointer",
          fontSize: "16px",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.3)",
        }}
      >
       <i class="bi bi-file-earmark-pdf-fill"></i> PDF Download 2026
      </button></a>
    </div>
  );
}
